import { Link, useLocation } from 'react-router-dom';
import React from 'react';
import { Box, Button, Center, Image, Text } from '@chakra-ui/react';
import Icon from '../../../shared/components/Icon';
import ActionButton from '../../../shared/components/ActionButton';

interface IPreviewImageProps {
  hasImage: boolean;
  previewImage: string;
  id: string;
  onDelete: () => void;
}

export function PreviewImage({ hasImage, previewImage, id, onDelete }: IPreviewImageProps) {
  const location = useLocation();

  const state = {
    backgroundLocation: location,
    mediaBannerId: id,
  };

  const emptyPreviewImage = (
    <Button
      as={Link}
      to="/midia/galeria"
      state={state}
      whiteSpace="inherit"
      variant="unstyled"
      width="full"
      height="full"
      display="block"
    >
      <Center
        flexDirection="column"
        height="400px"
        width="100%"
        backgroundColor="gray.5"
        color="gray.80"
        textAlign="center"
        padding="15px"
        fontSize="xl"
      >
        <Icon icon="icon-cloud-upload" fontSize="5xl" />
        <Text>Adicionar imagem</Text>
      </Center>
    </Button>
  );

  const renderPreviewImage = (
    <Box gap={4} display="flex" flexDirection="column" alignItems="center">
      <Box backgroundColor="white" height="400px" width="100%" position="relative">
        <Image src={previewImage} objectFit="cover" height="100%" width="100%" />
        <ActionButton
          icon={<Icon icon="icon-delete" fontSize="md" />}
          aria-label="Remover banner"
          title="Remover banner"
          backgroundColor="rgba(0,0,0,0.5)"
          color="white"
          position="absolute"
          top="8px"
          right="8px"
          height="30px"
          minWidth="30px"
          borderRadius="sm"
          _hover={{ backgroundColor: 'red.500' }}
          onClick={onDelete}
        />
      </Box>
      <Button
        as={Link}
        to="/midia/galeria"
        state={state}
        title="Editar banner"
        aria-label="Editar banner"
        width="full"
        colorScheme="primary"
      >
        Editar
      </Button>
    </Box>
  );

  return <Box width="100%">{hasImage ? renderPreviewImage : emptyPreviewImage}</Box>;
}
